import { Routes } from '@angular/router';
import { LoginComponent } from '@login';
import { HREF } from './constants/href-admin-panel.constant';
import { ShellComponent } from './shell/shell.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  {
    path: '',
    component: ShellComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: HREF.IMPORTS,
        loadComponent: () => import('./pages/imports/imports.component'),
      },
      {
        path: HREF.ORDERS,
        loadComponent: () => import('./pages/orders/orders.component'),
      },
      {
        path: HREF.PRODUCTS,
        loadComponent: () => import('./pages/products/products.component'),
      },
      {
        path: HREF.RESOURCE_UPLOAD,
        loadComponent: () => import('./pages/resource-upload/resource-upload.component'),
      },
      {
        path: HREF.PROMO_BANNERS,
        loadComponent: () => import('./pages/promo-banners/promo-banners.component'),
      },
      {
        path: HREF.ORDER,
        loadComponent: () => import('./pages/order-details-wrapper/order-details-wrapper.component'),
        children: [
          {
            path: HREF.DETAILS,
            loadComponent: () => import('./pages/order-details/order-details.component'),
          },
          {
            path: HREF.PROCESSING,
            loadComponent: () => import('./pages/order-processing/order-processing.component'),
          },
          {
            path: '**',
            redirectTo: HREF.DETAILS,
          },
        ],
      },
      {
        path: HREF.HERO_IMAGES,
        loadComponent: () => import('./pages/hero-images/hero-images.component'),
      },
      {
        path: `${HREF.HERO_IMAGES}/:id`,
        loadComponent: () => import('./pages/hero-image-overview/hero-image-overview.component'),
      },
      {
        path: HREF.REFUNDS,
        loadComponent: () => import('./pages/refunds/refunds.component'),
      },
      {
        path: HREF.PAYMENTS,
        loadComponent: () => import('./pages/payments/payments.component'),
      },
      {
        path: HREF.GENERAL_HOLD,
        loadComponent: () => import('./pages/general-hold/general-hold.component'),
      },
      {
        path: '**',
        redirectTo: HREF.IMPORTS,
      },
    ],
  },
];
